var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseAlt5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.9613C2 10.3537 2.27618 9.77909 2.75061 9.39954L10.7506 2.99954C11.481 2.41519 12.519 2.41519 13.2494 2.99954L21.2494 9.39954C21.7238 9.77909 22 10.3537 22 10.9613V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V10.9613Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseAlt5);
export default __webpack_public_path__ + "static/media/house-alt-5.710bcdddb148c967da532e781908f958.svg";
export { ForwardRef as ReactComponent };